module.exports = __webpack_public_path__ + "img/lab2.5915e263.png";